var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.284.625h3.86l-8.432 9.636 9.92 13.114h-7.766l-6.086-7.952-6.957 7.952H.957l9.018-10.309L.465.625h7.962l5.496 7.268 6.36-7.268Zm-1.357 20.442h2.139L7.263 2.812H4.965l13.961 18.255Z"
  })));
};
export default SvgTwitter;